import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/constants.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareDetailsRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-software-routes/src/projectSettingsSoftwareDetailsRoute.tsx';
import { ProjectSettingsDetailsSkeleton } from '@atlassian/jira-skeletons/src/ui/project-settings/ProjectSettingsFeaturesSkeleton.tsx';
import { softwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point';
import { projectDetailsPageEntrypoint } from '@atlassian/jira-spa-apps-project-settings-details/src/entrypoint.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { softwareOnboardingGetStartedIntegrationsStatusResource } from '@atlassian/jira-router-resources-jsw-onboarding/src/services/get-started-integrations-status/index.tsx';

import Details, { LazyDetailsSettings } from './ui/project-settings/details/index.tsx';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';

const projectSettingsSoftwareDetailsPageEntrypoint = createPageEntryPoint({
	main: projectDetailsPageEntrypoint,
});

export const projectSettingsSoftwareDetailsRouteEntry = createEntry(
	projectSettingsSoftwareDetailsRoute,
	() => ({
		group: 'project-settings-software',
		component: Details,
		skeleton: ProjectSettingsDetailsSkeleton,
		layout: softwareProjectLayout,

		entryPoint: () =>
			fg('jira_project_details_settings_refresh')
				? projectSettingsSoftwareDetailsPageEntrypoint
				: undefined,

		navigation: {
			horizontal: GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV,
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarNextGen,
			sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
		},

		resources: [
			...getSettingsNavigationResources(),

			resourceWithCondition2(
				() => fg('jira_slack_and_teams_promotion'),
				softwareOnboardingGetStartedIntegrationsStatusResource,
			),
		],
		forPaint: [LazyAtlassianNavigation, LazyDetailsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-software-entries/src/projectSettingsSoftwareDetailsRouteEntry.tsx',
				whichExportToUse: 'projectSettingsSoftwareDetailsRouteEntry',
			},

			enabled: true,
		},
	}),
);
